import {FC} from 'react'

import {Modal} from '@/components/common/modal/Modal'
import {theme} from '@/theme/theme'
import {DocumentLocation} from '@/utils/document/types'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {TrademarkImage} from '../content/TrademarkImage'

type FilePreviewModalProps = {
  isVisible: boolean
  closeModal: (e?: any) => void
  uploadedFile?: string
  document?: DocumentLocation
  hasBorder?: boolean
}

export const FilePreviewModal: FC<FilePreviewModalProps> = ({
  isVisible,
  closeModal,
  uploadedFile,
  document,
  hasBorder = false,
}) => (
  <>
    <Modal isVisible={isVisible} closeModal={closeModal}>
      <div className="image-wrapper">
        {uploadedFile ? (
          <img src={uploadedFile} alt="Logo" className="image" />
        ) : document ? (
          <TrademarkImage logoDocument={document} />
        ) : null}
      </div>
    </Modal>

    <style jsx>{`
      .image-wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .image {
        display: block;
        max-width: 100%;
        height: 100%;
        object-fit: contain;
        border: ${hasBorder ? `1px solid ${theme.palette.gray[200]}` : 'none'};
        max-height: calc(100vh - ${theme.spacing[7]} * 2 - ${theme.spacing[6]} * 2);
        max-height: calc(100svh - ${theme.spacing[7]} * 2 - ${theme.spacing[6]} * 2);
      }

      @media ${MOBILE_SCREENSIZE} {
        .image-wrapper {
          margin: ${theme.spacing[3]} auto;
        }
      }
    `}</style>
  </>
)
